import { useId } from "react";

import { useDroppable } from "@dnd-kit/core";

import { DRAGGABLE_TYPES } from "../constants";
import DndIndicator from "../Indicator";

const ItemPlaceholder = ({ data, index = 0 }) => {
  const id = useId();

  const { isOver, setNodeRef } = useDroppable({
    data: { ...data, accepts: [DRAGGABLE_TYPES.ITEM], index },
    id: `droppable-item--${id}`,
  });

  return (
    <div className="relative" ref={setNodeRef}>
      {isOver && <DndIndicator layout="horizontal" />}
    </div>
  );
};

export default ItemPlaceholder;
